import { HttpRequestMethods } from '@com-delta-idp/mnx-utils';

export interface FieldItem {
  key: string;
  value: string | boolean;
}

export interface GenericFormFields {
  fieldItem: FieldItem[];
  action: string;
  target: string;
  method: HttpRequestMethods;
}

export interface CurrencyMap {
  [key: string]: string;
}

export interface CurrencySymbol {
  currencyMap: CurrencyMap;
}

export interface CheckinForm {
  confirmationNumber: string;
  departureAirport: string;
  startFrom: string;
  searchType: string;
  boardingpassonly?: boolean;
}

export interface FlyreadyForm {
  bookingId: string;
  givenNames: string;
  surName: string;
  departureAirportCode: string;
}
